/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerModelMajorVersionDto } from '../models/EntityModelResponseContainerModelMajorVersionDto';
import type { ModelMajorVersionDto } from '../models/ModelMajorVersionDto';
import type { PagedModelEntityModelModelMajorVersionDto } from '../models/PagedModelEntityModelModelMajorVersionDto';
import type { PagedResourcesAssemblerModelMajorVersionDto } from '../models/PagedResourcesAssemblerModelMajorVersionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemDeviceSoftwareMajorVersionControllerService {
    /**
     * @returns PagedModelEntityModelModelMajorVersionDto OK
     * @throws ApiError
     */
    public static listAllMajors({
        assembler,
        modelId,
        startsWithFields,
        majorVersion,
        page,
        size = 100,
        sort,
    }: {
        assembler: PagedResourcesAssemblerModelMajorVersionDto,
        modelId?: string,
        startsWithFields?: Array<string>,
        majorVersion?: number,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelModelMajorVersionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/ota-updates/device-catalog',
            query: {
                'modelId': modelId,
                'startsWithFields': startsWithFields,
                'majorVersion': majorVersion,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns PagedModelEntityModelModelMajorVersionDto OK
     * @throws ApiError
     */
    public static listByModel({
        modelId,
        assembler,
        majorVersion,
        page,
        size = 100,
        sort,
    }: {
        modelId: string,
        assembler: PagedResourcesAssemblerModelMajorVersionDto,
        majorVersion?: number,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelModelMajorVersionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/ota-updates/device-catalog/models/{modelId}/majors',
            path: {
                'modelId': modelId,
            },
            query: {
                'majorVersion': majorVersion,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerModelMajorVersionDto OK
     * @throws ApiError
     */
    public static create({
        modelId,
        requestBody,
    }: {
        modelId: string,
        requestBody: ModelMajorVersionDto,
    }): CancelablePromise<EntityModelResponseContainerModelMajorVersionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/ota-updates/device-catalog/models/{modelId}/majors',
            path: {
                'modelId': modelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        modelId,
        force = false,
    }: {
        modelId: string,
        force?: boolean,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/ota-updates/device-catalog/models/{modelId}/majors/{majorId}',
            path: {
                'modelId': modelId,
            },
            query: {
                'force': force,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerModelMajorVersionDto OK
     * @throws ApiError
     */
    public static read({
        modelId,
    }: {
        modelId: string,
    }): CancelablePromise<EntityModelResponseContainerModelMajorVersionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/ota-updates/device-catalog/models/{modelId}/majors/{majorId}',
            path: {
                'modelId': modelId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerModelMajorVersionDto OK
     * @throws ApiError
     */
    public static update({
        modelId,
        requestBody,
    }: {
        modelId: string,
        requestBody: ModelMajorVersionDto,
    }): CancelablePromise<EntityModelResponseContainerModelMajorVersionDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/ota-updates/device-catalog/models/{modelId}/majors/{majorId}',
            path: {
                'modelId': modelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
